<div class="modal-header">
    <div class="cont__modal-title">
        <div class="m_{{operation.OperationCode}}"></div>
        <h3 class="modal-title">{{operation.Operation}}</h3>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <div [innerHtml]="htmlInfo"></div>

</div>
<div class="modal-footer">

    <div class="cost__operation">{{operation.FinalPrice | currency: 'EUR'}}</div>
    <div class="bots__actions">
        <button *ngIf="!operation.Included" type="button" class="btn btn-add" (click)="includeOperation()"><img src="../../../../assets/images/icons/add-icon.svg" alt="Añadir servicio"></button>
        <button *ngIf="operation.Included" type="button" class="btn btn-add" (click)="includeOperation()"><img src="../../../../assets/images/icons/quit-icon.svg" alt="Eliminar servicio"></button></div>

</div>